import { FronteggProvider } from '@frontegg/react';
import type { ReactNode } from 'react';
import type { FronteggConfig } from './config';

interface AuthProviderProps {
  children: ReactNode;
  config: FronteggConfig;
}

export function AuthProvider({ children, config }: AuthProviderProps) {
  return (
    <FronteggProvider
      authOptions={config.authOptions}
      contextOptions={config.contextOptions}
      hostedLoginBox={config.hostedLoginBox}
    >
      {children}
    </FronteggProvider>
  );
}
